export default class ContactModel {
    idNContacto: number | null;
    fldTNombre : string | null;
    fldTAlias: string | null;

    constructor() {
        this.idNContacto = null;
        this.fldTNombre = null;
        this.fldTAlias = null;
    }
} 